module.exports = __webpack_public_path__ + "static/media/pp_logo.2c8f7016.svg";